import { render, staticRenderFns } from "./goal-details.vue?vue&type=template&id=ecb1a6d6&scoped=true"
import script from "./goal-details.vue?vue&type=script&lang=js"
export * from "./goal-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb1a6d6",
  null
  
)

export default component.exports